export default __webpack_public_path__ + "static/ENG_ILGA_World_map_sexual_orientation_laws_dec2020-dcd09540aac0998bb4577d6234b482eb.png";